<div *ngIf="message" class="alert alert-{{ status }}" role="alert">
  <mat-icon *ngIf="icon" style="vertical-align: middle">{{ icon }}</mat-icon>
  <span>&nbsp;</span>
  <span [innerHTML]="message"></span>
</div>
